export const API_BASE = 'https://partnerprivacy-api.paragon.winrdata.com';

export const API_ROUTES = {
  OVERVIEW: `${API_BASE}/monthly-overview`,
  PARTNERS: `${API_BASE}/partners`,
  MONTHOVERMONTH: `${API_BASE}/monthovermonth`,
  DCUS: `${API_BASE}/urls`,
  COUNTRIES: `${API_BASE}/country_summary`,
  POLICIES: `${API_BASE}/policies`,
  POLICY_SUMMARY: `${API_BASE}/policy-summary`,
};